import React from 'react';

import styled from 'styled-components';

const StyledLessonTypesSection = styled.div`
  background-color: var(--white);
  color: var(--stile-grey-8);

  .content {
    padding: 0;

    @media (max-width: 768px) {
      margin: 0 25px;
    }

    .section-label {
      margin: 0 auto 25px auto;
      text-align: center;
      color: var(--stile-green-3);

      @media (max-width: 768px) {
        margin: 0 auto 20px auto;
      }
    }

    .section-heading {
      margin: 0 auto 80px auto;
      text-align: center;
      max-width: calc(8 / 12 * 100%);
      @media (max-width: 768px) {
        margin: 0 auto 40px auto;
        max-width: calc(6 / 8 * 100%);
      }
    }

    .section-content {
      margin: 0;
    }
  }
`;

export type LessonTypesSectionProps = {
  heading: string;
  content: React.ReactNode;
};

export default function LessonTypesSection({ heading, content }: LessonTypesSectionProps) {
  return (
    <StyledLessonTypesSection>
      <div className="content">
        <h6 className="h9 section-label">LESSON TYPES</h6>
        <h2 className="section-heading">{heading}</h2>
        <div className="section-content">{content}</div>
      </div>
    </StyledLessonTypesSection>
  );
}
